if (!window.CCDiscountToast) {
  (function () {
    class DiscountToast {
      constructor() {
        this.root = document.querySelector('[data-discount-toast]');
        if (!this.root) {
          return;
        }

        this.messageEl = this.root.querySelector('[data-discount-toast-message]');
        this.codeRow = this.root.querySelector('[data-discount-toast-code-row]');
        this.codeEl = this.root.querySelector('[data-discount-toast-code]');
        this.closeBtn = this.root.querySelector('[data-discount-toast-close]');
        this.defaultMessage = this.messageEl?.textContent?.trim() || '';
        this.timer = null;

        this.handleClick = this.handleClick.bind(this);
        this.handleCustomEvent = this.handleCustomEvent.bind(this);
        this.hide = this.hide.bind(this);

        document.addEventListener('click', this.handleClick, true);
        window.addEventListener('theme:discount-applied', this.handleCustomEvent);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isVisible()) {
            this.hide();
          }
        });

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', this.hide);
        }
      }

      get duration() {
        const fallback = (window.theme && window.theme.settings && window.theme.settings.discountToastDuration) || 4;
        return Number(fallback) * 1000;
      }

      isVisible() {
        return this.root.classList.contains('is-visible');
      }

      handleClick(event) {
        if (event.defaultPrevented || event.button > 0) {
          return;
        }

        const interactive = event.target.closest('a[href], button, [role="button"], input[type="submit"],[data-auto-discount]');
        if (!interactive || interactive.hasAttribute('data-no-discount-toast')) {
          return;
        }

        const hasDataAttr = interactive.hasAttribute('data-auto-discount') || interactive.hasAttribute('data-discount-code') || interactive.hasAttribute('data-discount-message');
        const matchesHref = interactive.matches('a[href*="discount="]');

        if (!hasDataAttr && !matchesHref) {
          return;
        }

        const detail = this.extractDetail(interactive);
        if (!detail) {
          return;
        }

        this.show(detail);
      }

      handleCustomEvent(event) {
        if (!event || !event.detail) {
          return;
        }
        this.show(event.detail);
      }

      extractDetail(element) {
        const detail = {};
        const datasetCode = element.getAttribute('data-auto-discount') || element.getAttribute('data-discount-code');
        const datasetMessage = element.getAttribute('data-discount-message');

        if (datasetCode) {
          detail.code = datasetCode.trim();
        }

        if (datasetMessage) {
          detail.message = datasetMessage.trim();
        }

        if (!detail.code) {
          const href = element.getAttribute('href') || element.getAttribute('data-url');
          if (href) {
            try {
              const url = new URL(href, window.location.origin);
              const discountFromUrl = url.searchParams.get('discount');
              if (discountFromUrl) {
                detail.code = discountFromUrl.trim();
              }
            } catch (err) {
              // ignore malformed URLs
            }
          }
        }

        if (!detail.code && !detail.message) {
          return null;
        }

        return detail;
      }

      show(detail = {}) {
        if (!this.root) {
          return;
        }

        const message = detail.message || this.defaultMessage;
        if (this.messageEl && message) {
          this.messageEl.textContent = message;
        }

        if (this.codeEl && detail.code) {
          this.codeEl.textContent = detail.code;
          this.codeRow?.classList.remove('is-hidden');
        } else if (this.codeRow) {
          if (this.codeEl) {
            this.codeEl.textContent = '';
          }
          this.codeRow.classList.add('is-hidden');
        }

        this.root.setAttribute('aria-hidden', 'false');
        this.root.classList.add('is-visible');
        this.startTimer();
      }

      hide() {
        if (!this.root) {
          return;
        }

        this.root.classList.remove('is-visible');
        this.root.setAttribute('aria-hidden', 'true');
        this.clearTimer();
      }

      startTimer() {
        this.clearTimer();
        this.timer = window.setTimeout(() => {
          this.hide();
        }, this.duration);
      }

      clearTimer() {
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      const enabled = window.theme && window.theme.settings && window.theme.settings.discountToastEnabled;
      if (!enabled) {
        return;
      }

      window.CCDiscountToast = new DiscountToast();
    });
  })();
}
